import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=123d5fb8&scoped=true"
import script from "./WangEditor.vue?vue&type=script&lang=ts"
export * from "./WangEditor.vue?vue&type=script&lang=ts"
import style0 from "./WangEditor.vue?vue&type=style&index=0&id=123d5fb8&prod&lang=less"
import style1 from "./WangEditor.vue?vue&type=style&index=1&id=123d5fb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d5fb8",
  null
  
)

export default component.exports